import React, { useState } from "react";
import ActivityModule from "@/components/ActivityModule";
import { TrackerTable, PageHeader, Tabs } from "@/components/shared";

const TABS = [
  { id: "activity", label: "Activity & KPIs" },
  { id: "edits", label: "Editing Log" },
];

export default function VideoEditing() {
  const [active, setActive] = useState("activity");
  return (
    <div>
      <PageHeader title="Video Editing" subtitle="Editors log daily edits — KPIs auto-calculate (completed, published, on-time)" />
      <Tabs tabs={TABS} active={active} onChange={setActive} />
      {active === "activity" ? <ActivityModule module="video_editing" /> : <TrackerTable id="edits" />}
    </div>
  );
}
